<template>
    <div class="">
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small"
                            @click="handleAddClass">
                            新增
                        </el-button>
                        <!-- <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">
                            新增常用语
                        </el-button> -->
                        <el-button type="primary" size="small" @click="begin">
                            刷新
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" :height="height" row-key="id" border
                highlight-current-row @current-change="handleCurrentChange" :tree-props="{children: 'child'}">
                <el-table-column prop="id" label="编号" width="100"></el-table-column>
                <el-table-column prop="name" label="内容">
                    <template slot-scope="{row}">
                        <div v-if="type==2">
                            <span v-if="row.pid==0">
                                {{row.name}}
                            </span>
                            <span v-else>
                                <el-image v-for="(m,i) in row.image" :key="i" style="width: 50px; height: 50px;margin-right:5px"
                                    :src="m.url" fit="cover" :preview-src-list="[m.url]"></el-image>
                            </span>
                        </div>
                        <div v-else> <span v-if="row.name">
                                {{row.name}}
                            </span>
                            <span v-else>{{row.content}}</span></div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="create_time" label="添加时间" show-overflow-tooltip width="170"></el-table-column> -->
                <el-table-column label="" width="200" align="center">
                    <template slot-scope="scope">
                        <div v-if="selectCurrent==scope.row.id ||selectCurrent_pid==scope.row.id">
                            <!-- <el-button size="mini" type="text" 
                                @click="handleEdit(scope.row,scope.$index)">1</el-button>
                            <el-button size="mini" type="text" 
                                @click="handleDelet(scope.row,scope.$index)">1</el-button> -->
                            <i class="el-icon-edit editbtn" @click="handleEdit(scope.row,scope.$index)"></i>
                            <i class="el-icon-delete editbtn" style=" margin-left:15px"
                                @click="handleDelet(scope.row,scope.$index)"></i>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- <el-dialog title="添加常用语" :visible.sync="dialogVisible" center width="40%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px" class="demo-ruleForm">
                    <el-form-item label="上级类别名称" prop='sz_type'>
                        <el-select v-model="ruleForm.sz_type" placeholder="请选择" size="small">
                            <el-option v-for="item in lb_options" :key="item.id"
                                :label="item.name_2?item.name_2:item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="常用语内容" prop='sz_name'>
                        <el-input v-model="ruleForm.sz_name" size="small"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog> -->
        <el-dialog title="添加分类" :visible.sync="dialogVisibleClass" center width="40%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleFormcalss" :rules="ruleClass" ref="ruleFormcalss" label-width="150px"
                    class="demo-ruleForm">
                    <el-form-item label="上级类别名称" prop='sz_type'>
                        <el-select v-model="ruleFormcalss.sz_type" placeholder="请选择" size="small">
                            <el-option v-for="item in lb_options" :key="item.id"
                                :label="item.name_2?item.name_2:item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="内容名称" :key="type"
                        :prop="type==2?(ruleFormcalss.sz_type==0?'calss_name':'nullrule'):'calss_name'">
                        <el-input v-model="ruleFormcalss.calss_name" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="图片" v-if="type==2">
                        <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
                            :headers="{ token:$store.state.user.token }" :data="{ image_class_id:'72',file_type:'1'}"
                            :file-list="ruleFormcalss.lb_mapList" :on-success="uploadSuccess" :on-remove="uploadRmove"
                            list-type="picture-card">
                            <i class="el-icon-plus"></i>
                            <!-- verification:1,fileS:2,fileH:300,fileW:300  -->
                        </el-upload>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submitClass('ruleFormcalss')" size="small" type="primary" :loading="subloading">提 交
                </el-button>
                <el-button @click="dialogVisibleClass = false" size="small">取 消</el-button>
            </span>
        </el-dialog>


    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        props: {
            type: {
                default: () => {
                    return 1
                }
            }
        },
        data() {
            return {
                loading: false,
                tableData: [],
                lb_options: [],
                currentPage: 1,
                pagesize: 15,
                height: null,
                // 
                eid: '0',
                dialogVisible: false,
                dialogVisibleClass: false,
                subloading: false,
                ruleForm: {
                    sz_type: '',
                    sz_name: '',
                    sz_sort: 50,
                    seo_describe: '',
                    seo_keyword: '',
                    seo_title: '',
                },
                ruleFormcalss: {
                    calss_name: '',
                    sz_type: 0,
                    lb_mapList: []
                },
                mapListed: [],
                rule: {
                    sz_name: [{
                        required: true,
                        message: '请填写类别名称',
                        trigger: 'blur'
                    }],
                },
                ruleClass: {
                    calss_name: [{
                        required: true,
                        message: '请填写分类名称',
                        trigger: 'blur'
                    }],
                },
                selectCurrent: '',
                selectCurrent_pid: '',
                // type:1
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            this.gettype()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 225 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 225 + 'px'
                }
            },
            //下拉框
            gettype() {
                let that = this
                that.lb_options = []
                axios.post("/admin/chatWordsCategory/categorySelect", {
                        type: this.type
                    }, {
                        token: true
                    })
                    .then(response => {
                        var arr = [{
                            id: 0,
                            name_2: '顶级类别'
                        }]
                        that.lb_options = [...arr, ...response.data.data]
                        this.ruleForm.sz_type = that.lb_options[0].id
                    })
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.tableData = []
                that.loading = true
                axios.post("/admin/chatWordsCategory/categorySelect", {
                        type: this.type
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data

                        var arr = [{
                            id: 0,
                            name_2: '顶级类别'
                        }]
                        that.lb_options = [...arr, ...response.data.data]
                        this.ruleForm.sz_type = that.lb_options[0].id

                    })
                    .catch(error => {})
            },

            handleCurrentChange(val) {
                let that = this
                this.selectCurrent = val.id
                this.selectCurrent_pid = val.pid
            },
            handleAdd() {
                let that = this
                that.dialogVisible = true
                that.eid = '0'
                that.form_clear()
            },
            handleAddClass() {
                this.dialogVisibleClass = true
                this.ruleFormcalss.calss_name = ''
                this.ruleFormcalss.sz_type = 0
            },
            form_clear() {
                let that = this
                // that.ruleForm.sz_name = ''
                this.ruleFormcalss.calss_name = ''
                this.ruleFormcalss.sz_type = 0
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        that.subloading = true
                        let urls;
                        if (this.eid && this.eid != '0') {
                            urls = "/admin/chatWords/update"
                        } else {
                            urls = "/admin/chatWords/save"
                        }
                        axios.post(urls, {
                                id: that.eid,
                                content: that.ruleForm.sz_name,
                                author: this.user.id,
                                category_id: this.ruleForm.sz_type,
                                sort: 50,
                                type: this.type
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.dialogVisible = false
                                    that.search()
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        return false;
                    }
                });
            },
            submitClass(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.type == 2) {
                            if (this.ruleFormcalss.sz_type == 0 && this.ruleFormcalss.calss_name == '')
                                return this.$message('请填写分类名称')
                            if (this.ruleFormcalss.sz_type != 0 && this.mapListed.length == 0) return this
                                .$message('请上传图片')
                        }
                        that.subloading = true
                        let urls;
                        if (this.eid && this.eid != '0') {
                            urls = "/admin/chatWordsCategory/update"
                        } else {
                            urls = "/admin/chatWordsCategory/save"
                        }
                        axios.post(urls, {
                                id: that.eid,
                                name: that.ruleFormcalss.calss_name,
                                author: this.user.id,
                                pid: this.ruleFormcalss.sz_type,
                                sort: 50,
                                type: this.type,
                                image: this.mapListed
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.dialogVisibleClass = false
                                    that.search()
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        return false;
                    }
                });
            },

            // 编辑
            handleEdit(row, index) {
                let that = this
                that.form_clear()
                that.dialogVisibleClass = true
                that.eid = row.id
                var data = row
                that.ruleFormcalss.calss_name = data.name
                that.ruleFormcalss.sz_type = data.pid
                this.ruleFormcalss.lb_mapList = []
                this.mapListed = []
                if (row.pid != 0) {
                    this.ruleFormcalss.lb_mapList = row.image
                    this.mapListed = row.image
                }


            },
            // 删除
            handleDelet(row, index) {
                let urls = '/admin/chatWordsCategory/del'
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post(urls, {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.search()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed.push(response.data)
            },
            uploadRmove(file, fileList) {
                var index = this.mapListed.findIndex(item => item.id == file.id)
                this.mapListed.splice(index, 1)
            },

        },

    };
</script>


<style scoped>
    .editbtn {
        color: #0078ff;
        cursor: pointer;
    }
</style>